import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosClientSignIn } from "../axios/api"; 
import { getSocket } from '../socket/socket';
// Thunk to fetch messages
export const fetchMessages = createAsyncThunk(
  'chat/fetchMessages',
  async (
    { senderId, receiverId, calling },
    { rejectWithValue }
  ) => {

    console.log(
      "================ FETCH MESSAGES START ================"
    );

    console.log("Calling From:", calling);

    console.log("Sender ID:", senderId);

    console.log("Receiver ID:", receiverId);

    try {

      console.log("Sending API Request...");

      const response = await axiosClientSignIn.get(
        '/chat/messages',
        {
          params: {
            sender: senderId,
            receiver: receiverId,
          },
        }
      );

      console.log("✅ API SUCCESS");

      console.log("Response Status:", response.status);

      console.log("Response Data:", response.data);

      console.log(
        "================ FETCH MESSAGES END ================"
      );

      return response.data;

    } catch (error) {

      console.log("❌ API ERROR");

      console.log("Error Object:", error);

      console.log("Error Response:", error.response);

      console.log("Error Data:", error.response?.data);

      console.log("Error Message:", error.message);

      console.log(
        "================ FETCH MESSAGES FAILED ================"
      );

      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

// Thunk to send file
export const sendFileMessage = createAsyncThunk(
  'chat/sendFileMessage',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post('/chat/messages/file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const OnCreateGroup = createAsyncThunk(
  'chat/createGroup',
  async (formData, { rejectWithValue }) => {
    console.log(formData,"formDataformDataformDataformData")
    try {
      const response = await axiosClientSignIn.post('/chat/creategroupchat', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const OnUpdateGroup = createAsyncThunk(
  'chat/OnUpdateGroup',
  async (formData, { rejectWithValue }) => {
    console.log(formData,"OnUpdateGroupOnUpdateGroupOnUpdateGroupOnUpdateGroupOnUpdateGroupOnUpdateGroupOnUpdateGroup")
    try {
      const response = await axiosClientSignIn.post('/chat/updategroupchat', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const OnDeleteGroup = createAsyncThunk(
  'chat/OnDeleteGroup',
  async (groupId, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post('/chat/deletegroupchat', { groupId }, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const OnGetMyGroups = createAsyncThunk(
  'chat/getMyGroups',
  async (_, { rejectWithValue }) => {

    try {
      const response = await axiosClientSignIn.get('/chat/getgroup');
          console.log("OnGetMyGroupsOnGetMyGroupsOnGetMyGroupsOnGetMyGroupsOnGetMyGroupsOnGetMyGroups")
      return response.data; // expected to be an array of groups
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



export const fetchGroupMessages = createAsyncThunk(
  'group/fetchMessages',
  async ({ groupId }, thunkAPI) => {
    try {
         console.log(groupId , "groupIdgroupIdgroupIdgroupIdgroupIdgroupIdgroupIdgroupId")
       const response = await axiosClientSignIn.post('/chat/group/messages', {
       groupId
      });
      return response.data.messages;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || { error: "Server error" });
    }
  }
);
export const sendFileGroupMessage = createAsyncThunk(
  'chat/sendFileGroupMessage',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post('/chat/groupmessages/file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    groupmessage:[],
    messages: [],
    loading: false,
    groups:[],
    error: null,
    // User presence state
    onlineUsers: {}, // { userId: { userName, lastSeen, isOnline } }
    presenceLoading: false,
  },
  reducers: {
    clearMessages: (state) => {
      state.messages = [];
      state.error = null;
    },
    // User presence reducers
    setUserOnline: (state, action) => {
      const { userId, userName, timestamp } = action.payload;
      state.onlineUsers[userId] = {
        userName,
        lastSeen: timestamp,
        isOnline: true,
        status: 'online'
      };
    },
    setUserOffline: (state, action) => {
      const { userId, timestamp } = action.payload;
      if (state.onlineUsers[userId]) {
        state.onlineUsers[userId].isOnline = false;
        state.onlineUsers[userId].lastSeen = timestamp;
        state.onlineUsers[userId].status = 'offline';
      }
    },
    updateUserPresence: (state, action) => {
      const { userId, isOnline, lastSeen, userName } = action.payload;
      state.onlineUsers[userId] = {
        userName: userName || state.onlineUsers[userId]?.userName || 'Unknown',
        lastSeen,
        isOnline,
        status: isOnline ? 'online' : 'offline'
      };
    },
    bulkUpdatePresence: (state, action) => {
      // Handle bulk presence updates from backend
      const presenceData = action.payload; // Array of user presence objects
      presenceData.forEach(user => {
        state.onlineUsers[user.userId] = {
          userName: user.userName,
          lastSeen: user.lastSeen,
          isOnline: user.isOnline,
          status: user.isOnline ? 'online' : 'offline'
        };
      });
    },
    clearPresence: (state) => {
      state.onlineUsers = {};
    },
    markMessagesRead: (state, action) => {
      const { messageIds, readAt } = action.payload;
      const ids = new Set(
        (Array.isArray(messageIds) ? messageIds : [messageIds])
          .filter(Boolean)
          .map((id) => id.toString())
      );
      if (!ids.size) return;

      const readTimestamp = readAt || new Date().toISOString();
      state.messages = state.messages.map((msg) =>
        ids.has(msg._id?.toString())
          ? { ...msg, isRead: true, readAt: readTimestamp }
          : msg
      );
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Messages
      .addCase(fetchMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload;
      })
      .addCase(fetchMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

       .addCase(fetchGroupMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGroupMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.groupmessage= action.payload;
      })
      .addCase(fetchGroupMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
 .addCase(OnCreateGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(OnCreateGroup.fulfilled, (state, action) => {
        state.loading = false;
      
      })
      .addCase(OnCreateGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  builder
    .addCase(OnGetMyGroups.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(OnGetMyGroups.fulfilled, (state, action) => {
      state.loading = false;
      state.groups = action.payload;
    })
    .addCase(OnGetMyGroups.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
      builder// Send File Message
      .addCase(sendFileMessage.fulfilled, (state, action) => {
  //       const msg = action.payload?.message;
  // const id = msg?._id;

  // // 1) How many times this reducer runs
  // console.count("✅ sendFileMessage.fulfilled reducer RUN");

  // // 2) Print the message id + file info (so you can match duplicates)
  // console.log("✅ fulfilled msg id:", id, {
  //   fileUrl: msg?.fileUrl,
  //   filetype: msg?.filetype,
  //   sender: msg?.sender?._id || msg?.sender,
  //   receiver: msg?.receiver?._id || msg?.receiver,
  //   sentAt: msg?.sentAt
  // });

  // // 3) Check if this exact message already exists in state BEFORE pushing
  // const already = id ? state.messages.some(m => m?._id === id) : false;
  // console.log("🟡 already exists in state before push?", already);

  // // 4) Count duplicates in state BEFORE push (proof)
  // if (id) {
  //   const ids = state.messages.map(m => m?._id).filter(Boolean);
  //   const dupCount = ids.filter(x => x === id).length;
  //   console.log("🟠 count of this id in state BEFORE push:", dupCount);
  // }

  // // Your existing logic
  // state.messages.push(msg);

  // 5) Count duplicates AFTER push (proof)
  // if (id) {
  //   const idsAfter = state.messages.map(m => m?._id).filter(Boolean);
  //   const dupCountAfter = idsAfter.filter(x => x === id).length;
  //   console.log("🔴 count of this id in state AFTER push:", dupCountAfter);
  // }
        // console.log(action.payload.message, " this full filed")
      //  state.messages.push(action.payload.message); // Append sent file message
      })
      .addCase(sendFileMessage.rejected, (state, action) => {
        state.error = action.payload;
      });

      builder// Send File Message
      .addCase(sendFileGroupMessage.fulfilled, (state, action) => {
        console.log(action.payload.groupmessage, " this full filed")
      //  state.groupmessage.push(action.payload.groupmessage); // Append sent file message
      })
      .addCase(sendFileGroupMessage.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { 
  clearMessages, 
  setUserOnline, 
  setUserOffline, 
  updateUserPresence, 
  bulkUpdatePresence, 
  clearPresence,
  markMessagesRead,

} = chatSlice.actions;
export default chatSlice.reducer;
